






















































import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import RemainWatcher from '@/components/User/Panels/RemainWatcher.vue';

@Component({
    components: {
        RemainWatcher,
    },
    computed: {
        ...mapGetters({
            userCurrentTicket: 'UserTickets/getUserCurrentTicket',
            ricketRemainWatcherVisibility: 'UserTickets/getRicketRemainWatcherVisibility',
        }),
    },
})
export default class UserTicketsAssignment extends Vue {
    public ticketsAssigneeSearchQuery: string = '';
    public roleAssigneeAll: boolean = false;
    public newAssignee: any = [];

    constructor() {
        super();
    }

    get ticketRoleAssignee() {
        const users = this.$store.getters['Tickets/getTicketRoleAssignee'];
        return this.ticketsAssigneeSearchQuery === '' ? users : users.filter((user: any) => {
            return user.person
                ? user.person.first_name.toLowerCase().includes(this.ticketsAssigneeSearchQuery.toLowerCase()) || user.person.family_name.toLowerCase().includes(this.ticketsAssigneeSearchQuery.toLowerCase())
                : user.name.toLowerCase().includes(this.ticketsAssigneeSearchQuery.toLowerCase());
        });
    }

    public getTicketRoleAssignee() {
        this.roleAssigneeAll = !this.roleAssigneeAll;
        this.fetchTicketRoleAssignee(this.roleAssigneeAll);
    }

    public changeTicketAssignee(assignee: any) {
        this.newAssignee = assignee;
        this.$store.commit(Mutations.TICKET_REMAIN_WATCHER_VISIBILITY, true);
    }

    public fetchTicketRoleAssignee(all: boolean) {
        const currentTicket = this.$store.getters['UserTickets/getUserCurrentTicket'];

        if (typeof currentTicket !== 'undefined') {
            this.$store.dispatch(Actions.FETCH_TICKET_ROLE_ASSIGNEE, {
                projectId: currentTicket.project_id,
                categoryId: currentTicket.category_id,
                all,
            });
        }
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffBackButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('header.re-assign', 'Re-assign'));
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
    }

    public mounted() {
        this.fetchTicketRoleAssignee(this.roleAssigneeAll);
    }
}
